module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 612
// module chunks = 0